import { Col, Row } from 'antd';
import Text from '@deprecated-ui/common/Text';
import AuthCardLayout from 'global/AuthCardLayout';
import { BackButton, ModalIllustration } from './styled';

interface OtpLimitProps {
  title?: string;
  description?: string;
  buttonText?: string;
  onBackClick?(): void;
}

const OtpLimit = ({
  title = 'Try Again After 1 Hour',
  description = 'You have reached 5 times OTP sending limit.',
  buttonText = 'Back',
  onBackClick = () => {},
}: OtpLimitProps) => (
  <AuthCardLayout wrapperClassName="register" withLogo={false}>
    <Row justify="center" gutter={[0, 24]}>
      <Col>
        <Row align="middle" justify="center">
          <Col>
            <ModalIllustration src="/images/phone-otp-timer.svg" />
          </Col>
        </Row>
      </Col>

      <Col>
        <Row align="middle" justify="center" gutter={[0, 16]}>
          <Col span={24}>
            <Text
              align="center"
              weight="700"
              size="24px"
              height="32px"
              color="#333333"
            >
              {title}
            </Text>
          </Col>
          <Col span={24}>
            <Text align="center" size="16px" height="22px" color="#858585">
              {description}
            </Text>
          </Col>
        </Row>
      </Col>
    </Row>

    <Row>
      <Col span={24}>
        <BackButton type="primary" onClick={onBackClick}>
          {buttonText}
        </BackButton>
      </Col>
    </Row>
  </AuthCardLayout>
);

export default OtpLimit;
